import { render, staticRenderFns } from "./RegistrationAddress.vue?vue&type=template&id=7fe06e4d&scoped=true&"
import script from "./RegistrationAddress.vue?vue&type=script&lang=js&"
export * from "./RegistrationAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe06e4d",
  null
  
)

export default component.exports